import { Chord } from './models/Chord';
import * as Interval from './models/Interval';
import { Note } from './models/Note';

const invalidChord = Symbol('invalid chord');
const has = (chord: Chord, interval: Interval.Interval) =>
  chord.notes.includes(interval(chord.root));

export function chord(selectedNotes: Note[], root: Note): Chord | undefined {
  if (selectedNotes.length < 2) return undefined;

  const name = Note[root];
  const chord = {
    root,
    name,
    notes: selectedNotes,
    omit: [],
    add: {},
    sus: undefined,
  };

  try {
    checkRoot(chord);
  } catch (e) {
    if (e === invalidChord) {
      return undefined;
    } else {
      throw e;
    }
  }

  return chord;
}

function checkRoot(chord: Chord) {
  if (!has(chord, Interval.unison)) {
    chord.omit.push(1);
  }
  check3rd(chord);
}

function check3rd(chord: Chord) {
  if (has(chord, Interval.maj3)) {
    check5th(chord);
  } else if (has(chord, Interval.min3)) {
    chord.name += 'min';
    check5th(chord);
  } else {
    checkSuspended(chord);
  }
}

function checkSuspended(chord: Chord) {
  if (has(chord, Interval.perf4)) {
    chord.sus = 4;
  } else if (has(chord, Interval.maj2)) {
    chord.sus = 2;
  } else if (has(chord, Interval.perf5)) {
    chord.name += '5';
  } else {
    chord.omit.push(3);
  }

  check5th(chord);
}

function check5th(chord: Chord) {
  if (!has(chord, Interval.perf5)) {
    if (has(chord, Interval.dim5) && !has(chord, Interval.maj3)) {
      chord.add[5] = '♭';
    } else if (has(chord, Interval.aug5) && !has(chord, Interval.min3)) {
      chord.add[5] = '♯';
    } else {
      chord.omit.push(5);
    }
  }
  check7th(chord);
}

function check7th(chord: Chord) {
  if (has(chord, Interval.min7)) {
    chord.add[7] = '';
  }
  if (has(chord, Interval.maj7)) {
    if (chord.add[7] != null) throw invalidChord;
    chord.add[7] = 'maj';
  }
  check9th(chord);
}

function check9th(chord: Chord) {
  if (has(chord, Interval.maj2) && chord.sus !== 2) {
    chord.add[9] = '';
  }
  if (has(chord, Interval.min2)) {
    if (chord.add[9] != null) throw invalidChord;
    chord.add[9] = '♭';
  }
  if (has(chord, Interval.min3) && has(chord, Interval.maj3)) {
    if (chord.add[9] != null) throw invalidChord;
    chord.add[9] = '♯';
  }
  check11th(chord);
}

function check11th(chord: Chord) {
  if (has(chord, Interval.perf4) && chord.sus !== 4) {
    chord.add[11] = '';
  }
  if (has(chord, Interval.aug4) && chord.add[5] !== '♭') {
    if (chord.add[11] != null) throw invalidChord;
    chord.add[11] = '♯';
  }
  check13th(chord);
}

function check13th(chord: Chord) {
  if (has(chord, Interval.min6) && chord.add[5] !== '♯') {
    chord.add[13] = '♭';
  }
  if (has(chord, Interval.maj6)) {
    if (chord.add[13] != null) throw invalidChord;
    chord.add[13] = '';
  }
}
